module.exports = __webpack_public_path__ + "media/images/coelho-2e565aabc19bb619bca44a6061545d9e.jpg";